import { useStyletron } from "baseui";
import { StyledSvg } from "baseui/icon";
import React from "react";

export const SmallArrowIcon = (props: React.ComponentProps<typeof StyledSvg> & { direction: "up" | "down" | "left" | "right" }) => {
  const [_, $theme] = useStyletron();
  let rotation = 0;
  if (props.direction == "down") {
    rotation = 90;
  } else if (props.direction == "left") {
    rotation = 180;
  } else if (props.direction == "up") {
    rotation = -90;
  }

  return (
    <StyledSvg viewBox="0 0 16 16" {...props}>
      <path
        d="M8.068 11.244L10.658 8.65401H3V7.33801H10.658L8.068 4.762L8.95 3.88L13.08 8.01L8.95 12.126L8.068 11.244Z"
        fill={props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : "currentcolor")}
        style={{
          transform: `rotate3d(0, 0, 1, ${rotation}deg)`,
          transformOrigin: "center",
        }}
      />
    </StyledSvg>
  );
};
